import { render, staticRenderFns } from "./MatchPairSlideOptions.vue?vue&type=template&id=64be7416&scoped=true&"
import script from "./MatchPairSlideOptions.vue?vue&type=script&lang=js&"
export * from "./MatchPairSlideOptions.vue?vue&type=script&lang=js&"
import style0 from "./MatchPairSlideOptions.vue?vue&type=style&index=0&id=64be7416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be7416",
  null
  
)

export default component.exports